export const blobToBase64 = (blob: Blob): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onerror = () => {
      reader.abort();
      reject(new Error('❌ Error al convertir Blob a Base64'));
    };

    reader.onloadend = () => {
      resolve(reader.result as string); // <-- forzamos a string porque sabemos que lo es
    };

    reader.readAsDataURL(blob);
  });
};
